import { GAEventName } from 'analytics/ga-event-name.enum';
import { createAnalyticsEvent } from '../create-analytics-event';

export const swapToTravelPackClickEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.SWAP_TO_TRAVELPACK_TOGGLE,
  subscriptionId,
  location
}));

export const swapToPouchClickEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.SWAP_TO_POUCH_TOGGLE,
  subscriptionId,
  location
}));

export const nextOrderOnlyClickEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.NEXT_ORDER_ONLY_TOGGLE,
  subscriptionId,
  location
}));

export const swapToTravelPackEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.SWAP_TO_TRAVELPACK,
  subscriptionId,
  location
}));

export const swapToPouchEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.SWAP_TO_POUCH,
  subscriptionId,
  location
}));

export const nextOrderOnlyEvent = createAnalyticsEvent<{
  subscriptionId: number;
  location: string;
}>(({ subscriptionId, location }) => ({
  event: GAEventName.NEXT_ORDER_ONLY,
  subscriptionId,
  location
}));
